import { useEffect, useState } from "react";

import {
    COUNTDOWN_INTERVAL,
    type IDiscountTimeParams,
    type ITimeLeft,
    ZERO_TIME_LEFT,
} from "app/components/discountCampaign/DiscountBanner/utils/consts";
import { calculateTimeLeft } from "app/components/discountCampaign/DiscountBanner/utils/helpers";

export const useTimeLeft = ({ discountEndTime }: IDiscountTimeParams): ITimeLeft => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft({ discountEndTime }));

    useEffect(() => {
        const initial = calculateTimeLeft({ discountEndTime });
        if (initial === ZERO_TIME_LEFT) {
            setTimeLeft(ZERO_TIME_LEFT);
            return;
        }

        setTimeLeft(initial);

        const intervalId = setInterval(() => {
            const newTimeLeft = calculateTimeLeft({ discountEndTime });
            setTimeLeft(newTimeLeft);
            if (newTimeLeft === ZERO_TIME_LEFT) {
                clearInterval(intervalId);
            }
        }, COUNTDOWN_INTERVAL);

        return () => clearInterval(intervalId);
    }, [discountEndTime]);
    return timeLeft;
};
